export default __webpack_public_path__ + "static/media/home2.97a839de.png";